/*
 * Declares primary page work to the SSR runtime; complete only after successful DOM commit.
 * Normal browsers and older renderers get a no-op, preserving mixed-version behavior.
 */
export function beginSSRRender(): () => void {
  const runtime = (window as any).__RLP_SSR__ === true && (window as any).__RLP_SSR_RENDER__;
  return runtime ? runtime.begin() : () => {};
}
